import { DEFAULT_USER_LANGUAGE } from '../constants/common';
import { HttpHeaders } from '../interfaces';
import { getUserLanguagePreferenceKey } from '../session/session.helpers';
import {
  API_KEY_HEADER,
  AUTHORIZATION_HEADER,
  DISTRIBUTION_CHANNEL,
  DISTRIBUTION_CHANNEL_HEADER,
  INVENTORY_STORE_ID_HEADER,
  LANGUAGE_HEADER,
  SALES_CHANNEL_ID_HEADER,
  SESSION_ID_HEADER,
  SYSTEM_ID_HEADER
} from './api.constants';
import { ApiInstanceConfiguration } from './api.interfaces';

/** Set HTTP headers on the API request. */
export function setHeaders(
  apiInstanceConfigHeaders: HttpHeaders,
  sessionConfig: ApiInstanceConfiguration
): HttpHeaders {
  const headers = { ...apiInstanceConfigHeaders };

  Object.keys(headers).forEach((header) => {
    if (API_KEY_HEADER === header) {
      headers[header] = sessionConfig.apiKey;
    } else if (AUTHORIZATION_HEADER === header) {
      headers[header] = `Bearer ${sessionConfig.sessionId}`;
    } else if (DISTRIBUTION_CHANNEL_HEADER === header) {
      headers[header] = DISTRIBUTION_CHANNEL.ID;
    } else if (LANGUAGE_HEADER === header) {
      headers[header] =
        sessionConfig.preferences.Language ||
        sessionConfig.preferences[
          getUserLanguagePreferenceKey(sessionConfig.systemId)
        ] ||
        sessionConfig.buLanguage ||
        DEFAULT_USER_LANGUAGE;
    } else if (SESSION_ID_HEADER === header && sessionConfig.sessionId) {
      headers[header] = sessionConfig.sessionId;
    } else if (SYSTEM_ID_HEADER === header && sessionConfig.systemId) {
      headers[header] = sessionConfig.systemId;
    } else if (SALES_CHANNEL_ID_HEADER === header) {
      headers[header] = sessionConfig?.userDefaultSalesChannelId;
    } else if (INVENTORY_STORE_ID_HEADER === header) {
      headers[header] = sessionConfig?.userDefaultInventoryStoreId;
    }
  });

  return headers;
}
